import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import { useAppDispatch, useAppSelector } from "../../useStore";
import swal from 'sweetalert';
import { reset, updateApplicationInterviewStatus } from "../../features/Applicant/applicantSlice";
import { Spinners } from "../TableOptions";
import { dropoutOption } from "../JobInputData";
import ModalHeader from "../ModalHeader";

const DropOutModal = ({ title, id, name }) => {
  const { updateApplicationInterviewStatusisSuccess, updateApplicationInterviewStatusisError, updateApplicationInterviewStatusisLoading, updateApplicationInterviewStatusmessage } = useAppSelector((state: any) => state.applicant);
  const dispatch = useAppDispatch();

  const [welcome, setWelcome] = useState(false);
  const handleCloseWelcome = () => setWelcome(false);
  const handleWelcome = () => setWelcome(true);
  const [inputs, setInputs] = useState({
    status: "",
    body: "",
    id: ""
  });

  const handleOnChange = (input: any, value: any) => {
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: value,
    }));
  };

  useEffect(() => {
    setInputs((prevState: any) => {
      return {
        ...prevState,
        id: id,
      };
    });
  }, [inputs?.status, inputs?.body, inputs?.id, setInputs, id]);






  useEffect(() => {
    if (updateApplicationInterviewStatusisError) {
      swal({
        title: "error",
        text: updateApplicationInterviewStatusmessage,
        icon: "error"
      })
      dispatch(reset())
    } else if (updateApplicationInterviewStatusisSuccess) {
      setInputs({
        status: "",
        body: "",
        id: ""
      })
      setWelcome(false)
      dispatch(reset())
    }

  }, [dispatch,
    updateApplicationInterviewStatusisError,
    updateApplicationInterviewStatusisSuccess,
    updateApplicationInterviewStatusmessage])


  const handleUpdate = () => {
    // @ts-ignore
    dispatch(updateApplicationInterviewStatus(inputs));
  };


  return (
    <div>
      <div onClick={handleWelcome} className="more-button">
        {title}
      </div>

      <Modal show={welcome} onHide={handleCloseWelcome} centered>
        <ModalHeader setShow={setWelcome} headerTitle={"Dropout"} />
        <Modal.Body>
          <form>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              <p>{name}</p>
            </div>
            <div className="schedule-setting"  >
              <select className="round"
                value={inputs.status}
                onChange={(e) => handleOnChange("status", e.target.value)}>
                <option>Select Status</option>
                {dropoutOption.map((item: any, i: any) => (
                  <option key={i} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="welcome-email">
              <h5>Comment</h5>
              <TextField
                id="outlined-multiline-static"
                multiline
                fullWidth
                type="text"
                minRows={4}
                variant="outlined"
                style={{ margin: "10px 0" }}
                value={inputs.body}
                onChange={(e) => handleOnChange("body", e.target.value)}
              />
            </div>

          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWelcome}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleUpdate}>
            {updateApplicationInterviewStatusisLoading ? <Spinners size={"sm"} /> : 'Send'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DropOutModal;
